import * as yup from 'yup';

const today = new Date();
const maxDate = new Date(today.getFullYear() + 1, today.getMonth(), today.getDate() + 1);
const maxDateString = maxDate.toISOString().split('T')[0];

export const standardSchema = yup.object({
  name: yup.string().required('Name is required'),
  description: yup.string().nullable(),
  issuedDate: yup
    .string()
    .nullable()
    .test('max-date', `Ngày phát hành không được vượt quá ${maxDateString}`, function (value) {
      if (!value) return true;
      return value <= maxDateString;
    }),
  effectiveDate: yup.string().nullable(),
  endDate: yup.string().nullable(),
  parameterStandards: yup.array().of(
    yup.object({
      parameterId: yup.number().required('Parameter ID is required'),
      standardId: yup.number().nullable(),
      standardA: yup.string()
        .required('Standard A is required')
        .test('no-comma', 'Không được sử dụng dấu phẩy, vui lòng sử dụng dấu chấm', value => !value || !value.includes(','))
        .test('is-number', 'Phải là số', value => !isNaN(parseFloat(value)))
        .test('is-positive', 'Phải lớn hơn hoặc bằng 0', value => parseFloat(value) >= 0)
        .test('valid-decimal-format', 'Định dạng số không hợp lệ, chỉ chấp nhận dấu chấm cho số thập phân',
          value => /^\d+(\.\d+)?$/.test(value))
      ,
      standardB: yup.string()
        .nullable()
        .test('no-comma', 'Không được sử dụng dấu phẩy, vui lòng sử dụng dấu chấm', value => !value || !value.includes(','))
        .test('is-number', 'Phải là số', value => !value || !isNaN(parseFloat(value)))
        .test('is-positive', 'Phải lớn hơn hoặc bằng 0', value => !value || parseFloat(value) >= 0)
        .test('valid-decimal-format', 'Định dạng số không hợp lệ, chỉ chấp nhận dấu chấm cho số thập phân',
          value => !value || /^\d+(\.\d+)?$/.test(value))
        .test('greater-than-a', 'Phải lớn hơn hoặc bằng Tiêu chuẩn A', function (value) {
          if (!value) return true;
          const standardA = this.parent.standardA;
          return !standardA || parseFloat(value) >= parseFloat(standardA);
        }),
      standardC: yup.string()
        .nullable()
        .test('no-comma', 'Không được sử dụng dấu phẩy, vui lòng sử dụng dấu chấm', value => !value || !value.includes(','))
        .test('is-number', 'Phải là số', value => !value || !isNaN(parseFloat(value)))
        .test('is-positive', 'Phải lớn hơn hoặc bằng 0', value => !value || parseFloat(value) >= 0)
        .test('valid-decimal-format', 'Định dạng số không hợp lệ, chỉ chấp nhận dấu chấm cho số thập phân',
          value => !value || /^\d+(\.\d+)?$/.test(value))
        .test('greater-than-b', 'Phải lớn hơn hoặc bằng Tiêu chuẩn B', function (value) {
          if (!value) return true;
          const standardB = this.parent.standardB;
          return !standardB || parseFloat(value) >= parseFloat(standardB);
        })
        .test('greater-than-a', 'Phải lớn hơn hoặc bằng Tiêu chuẩn A', function (value) {
          if (!value) return true;
          const standardA = this.parent.standardA;
          return !standardA || parseFloat(value) >= parseFloat(standardA);
        }),
    })
  ).default([]),
});